import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Layouts from '../layouts/Layouts';
import { AllInbox, BusinessCenter, WorkOff } from '@mui/icons-material';

const Financial = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Layouts>
            <div>
                <h1>Laporan Keuangan</h1>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/financial/data`} className={` sub-menu-item ${split[3] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <BusinessCenter />
                                        </div>
                                        <span>Laporan Keuangan</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/financial/piutang`} className={` sub-menu-item ${split[3] === 'piutang'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <WorkOff />
                                        </div>
                                        <span>Laporan Piutang</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/financial/hutang`} className={` sub-menu-item ${split[3] === 'hutang'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <AllInbox />
                                        </div>
                                        <span>Laporan Hutang</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Layouts>
    )
}

export default Financial
